import React, {Component} from 'react';
import {CustomInput} from "../Inputs";

class RegisterAddressInput extends Component {
    constructor() {
        super();
        this.state = {
            fieldValue: ''
        }
    }

    /*render() {
        return (
            <div>
                {Object.entries(this.props.address_components).map((e, i) => {
                    console.log(e[1])
                    if (e[1].types.includes(this.props.fieldNameEN)) {
                        //console.log('include', this.props.fieldNameEN)
                        return (
                            <CustomInput
                                key={i}
                                type="text"
                                readOnly={true}
                                placeholder={this.props.fieldNameHU}
                                value={e[1].long_name}
                                disabled={true}
                            />
                        )

                    }
                })}

            </div>
        );
    }*/

    setFieldValue = () => {
        Object.entries(this.props.address_components).map((e, i) => {
            //console.log(e[1])
            if (e[1].types.includes(this.props.fieldNameEN)) {
                //console.log('include', this.props.fieldNameEN)
                //console.log(e[1].long_name)
                if(this.props.fieldNameEN === 'country' && e[1].short_name === 'HU'){
                    this.setState({fieldValue: 'Magyarország'})

                } else {
                    this.setState({fieldValue: e[1].long_name})
                }

            }
        })
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        //console.log('prev',prevProps)
        //console.log('curr',this.props)
        if (this.props.address_components !== prevProps.address_components) {
            //console.log('updated', this.props.fieldNameEN)
            this.setState({fieldValue: ''})
            this.setFieldValue()

        }

    }

    componentDidMount() {
        this.setFieldValue()
    }

    render() {
        //console.log('rerender',this.props.fieldNameEN, this.state.fieldValue)
        return (
            <div>
                <CustomInput
                    type="text"
                    readOnly={true}
                    placeholder={this.props.fieldNameHU}
                    value={this.state.fieldValue}
                    disabled={true}
                />
            </div>
        );
    }

}

export default RegisterAddressInput;